// This is just an example,
// so you can safely delete all default props below

export default {
  failed: 'Action failed',
  success: 'Action was successful',
  index: {
    operation: '取扱説明書',
    app_store: '商用ライセンス',
    signin: 'アクセス アドレス:',
    app_title: 'アプリのタイトル',
    slogan: 'スローガン',
    server: 'リクエストアドレス',
    index_title: '倉庫管理プラットフォーム',
    webtitle: 'GreaterWMS--オープンソース倉庫管理システム',
    home: 'ホーム',
    title: 'GreaterWMS',
    title_tip: 'GreaterWMSホームページ',
    hide_menu: 'メニューを折りたたむ',
    api: 'APIドキュメント',
    translate: '言語の変更',
    unread: '未読メッセージ',
    login: '登録',
    register: 'ログイン',
    login_tip: '管理者として登録',
    register_tip: '管理人に登録する',
    logout: 'ログインを終了',
    user_login: 'ユーザーログイン',
    admin_login: '管理者ログイン',
    return_to_login: 'ログインページに戻る',
    user_center: 'ユーザーセンター',
    change_user: 'ユーザーの変更',
    view_my_openid: '私のOPENIDを表示',
    your_openid: 'あなたのOPENID',
    contact_list: '最近の連絡先',
    chat_more: 'より歴史的なニュース',
    chat_no_more: 'これ以上メッセージはありません',
    chat_send: '送信',
    previous: '前のページ',
    next: '次のページ',
    admin_name: '管理者',
    password: 'パスワード',
    confirm_password: 'パスワードの確認',
    staff_name: 'ユーザー名',
    cancel: 'キャンセル',
    close: '閉じる',
    submit: '送信',
    download: 'ダウンロード',
    updatetitle: 'アップグレードの準備ができました',
    updatedesc: 'バージョンをアップグレードする準備ができました',
    update: '今すぐ写新',
    chart: 'レポート',
    current_user: '現在の使用者'
  },
  Settings: {
    index: '設定',
    server: 'サーバ',
    equipment: 'デバイスのサポート'
  },
  menuItem: {
    dashboard: 'レポートセンター',
    inbound: '入庫管理',
    outbound: '配送管理',
    stock: '在庫管理',
    finance: '金融センター',
    goods: '製品管理',
    baseinfo: '基本設定',
    warehouse: '倉庫設定',
    staff: 'ユーザー管理',
    driver: 'ドライバー管理',
    customerdn: '顧客の注文',
    supplierasn: 'サプライヤーの注文',
    uploadcenter: 'アップロードセンター',
    downloadcenter: 'ダウンロードセンター',
    cloudwarehouse: '万倉インターコネクト'
  },
  contact: 'すぐに連絡する',
  sendmessage: '彼にメッセージを送信してください',
  send: '送信',
  nomoremessage: 'これ以上メッセージはありません',
  loadmore: 'もっと読み込む',
  new: '新規',
  newtip: '新しいデータを追加する',
  refresh: '写新',
  refreshtip: 'すべてのデータを写新',
  edit: 'このデータを編集する',
  confirmedit: '編集データの確認',
  canceledit: '編集データのキャンセル',
  delete: 'このデータを削除',
  deletetip: 'この操作は元に戻せません。 ',
  verifydelete: 'データを削除することを確認します',
  canceldelete: '削除データのキャンセル',
  download: 'ダウンロード',
  downloadtip: 'すべてのデータをダウンロードする',
  frombin: '場所から',
  movetobin: 'ライブラリを移動',
  putaway: '荷物が棚に上がる',
  cyclecount: '動的棚卸し',
  cyclecountrecorder: '在庫記録',
  search: 'キーワード検索',
  creater: '作成者',
  createtime: '作成時間',
  updatetime: '写新時間',
  action: 'オペレーティング',
  previous: '前のページ',
  next: '次のページ',
  no_data: 'これ以上のデータはありません',
  submit: '確認',
  cancel: 'キャンセル',
  estimate: '見積もり送料',
  downloadasnlist: 'ダウンロードリスト',
  downloadasndetail: 'ダウンロードの詳細',
  downloadasnlisttip: '到着通知リストのダウンロード',
  downloadasndetailtip: '到着通知の詳細をダウンロードする',
  printthisasn: '到着通知を表示',
  confirmdelivery: 'が到着したことを確認します',
  finishloading: 'アンロードが完了したことを確認します',
  confirmsorted: '並べ替えが完了したことを確認します',
  downloaddnlist: 'ダウンロードリスト',
  downloaddndetail: 'ダウンロードの詳細',
  downloaddnlisttip: '請求書リストのダウンロード',
  downloaddndetailtip: '請求書の詳細をダウンロードする',
  release: 'マッチオーダー',
  releaseallorder: 'すべてのピックオーダーを生成します',
  releaseorder: 'ピッキングオーダーの生成',
  print: '印刷ピッキングオーダー',
  printthisdn: '請求書を表示して印刷する',
  confirmorder: '注文の確認',
  confirmpicked: 'ピッキングが完了したことの確認',
  dispatch: '輸送する',
  deletebackorder: 'バックオーダーを削除する',
  confirminventoryresults: '在庫結果の確認',
  baseinfo: {
    company_info: '会社情報',
    supplier: 'サプライヤー',
    customer: '顧客',
    view_company: {
      company_name: '会社名',
      company_city: '都市名',
      company_address: '住所',
      company_contact: '連絡先情報',
      company_manager: '担当者',
      error1: '会社名を入力してください。',
      error2: '会社のある都市を入力してください。',
      error3: '会社の住所を入力してください。',
      error4: '会社の連絡先を入力してください。',
      error5: '社長を入力してください。'
    },
    view_supplier: {
      supplier_name: 'サプライヤー名',
      supplier_city: '都市名',
      supplier_address: '住所',
      supplier_contact: '連絡先情報',
      supplier_manager: '担当者',
      supplier_level: 'サプライヤーレベル',
      error1: 'サプライヤー名を入力してください。',
      error2: 'サプライヤーがいる都市を入力してください。',
      error3: 'サプライヤーの住所を入力してください。',
      error4: 'サプライヤーの連絡先を入力してください。',
      error5: 'サプライヤーマネージャーを入力してください。',
      error6: 'サプライヤーのレベルを入力してください。'
    },
    view_customer: {
      customer_name: '顧客名',
      customer_city: 'ホームシティ',
      customer_address: '住所',
      customer_contact: '連絡先情報',
      customer_manager: '担当者',
      customer_level: '顧客レベル',
      error1: '顧客名を入力してください。',
      error2: 'お客様のところの都市を入力してください。',
      error3: 'お客様の住所を入力してください。',
      error4: '取引先の連絡先を入力してください。',
      error5: 'クライアントマネージャーを入力してください。',
      error6: '顧客レベルを入力してください。'
    }
  },
  dashboards: {
    outbound_statements: '出庫報告書',
    inbound_statements: '受入報告書',
    inbound_and_outbound_statements: 'インバウンドとアウトバウンド',
    total_sales: '総売上高',
    category_sales_ranking: '商品別販売ランキング',
    sales_volume_ranking: '売上ランキング',
    sales_volumes_ranking: '売り上げランキング',
    total_receipts: '総受入量',
    category_receipt_ranking: '品類受入ランキング',
    receiving_quantity_ranking: '受入数量ランキング',
    Receiving_amount_ranking: '受入額ランキング',
    view_tradelist: {
      mode_code: '取引方式',
      bin_name: 'ライブラリ名',
      goods_code: '商品コード',
      goods_qty: '既存数量',
      creater: '作成者',
      update_time: '更新時間',
      create_time: '作成時間',
      inbound: 'にうけ',
      outbound: 'おくりだす'
    }
  },
  finance: {
    capital: '固定資産',
    freight: '輸送コスト',
    view_capital: {
      capital_name: '固定資産名',
      capital_qty: '数量',
      capital_cost: '費用',
      error1: '資産名を入力してください。',
      error2: '資産の数は必ず0を超えなければならない。',
      error3: '資産金額は0を超えなければならない。'
    },
    view_freight: {
      transportation_supplier: '輸送業者',
      send_city: '出発都市',
      receiver_city: '目的地の都市',
      weight_fee: '重量コスト',
      volume_fee: 'ボリュームコスト',
      min_payment: '最小コスト',
      error1: '運送業者を入力してください',
      error2: '送信都市を入力してください。',
      error3: '受信都市を入力してください。',
      error4: '一キロ当たりの運送費は0を超えなければなりません。',
      error5: '一立方メートルの運送費は必ず0を超えなければなりません。',
      error6: '最小運賃は0より大きくなければなりません。'
    }
  },
  driver: {
    driver: 'ドライバー管理',
    dispatchlist: '配達記録',
    error1: '運転手の名前を入力してください。',
    error2: '車のナンバーを入力してください',
    error3: '連絡先を入力してください',
    view_driver: {
      driver_name: 'ドライバー名',
      license_plate: 'ナンバープレート番号',
      contact: '連絡先情報'
    },
    view_dispatch: {
      driver_name: 'ドライバー名',
      dn_code: '注文号',
      contact: '連絡先情報'
    }
  },
  upload_center: {
    initializeupload: 'アップロードを初期化',
    uploadfiles: 'ファイルをアップロード',
    upload: 'アップロード',
    uploadcustomerfile: '顧客リストをアップロードする',
    uploadgoodslistfile: '商品表をアップロードする',
    uploadsupplierfile: 'サプライヤーリストをアップロードする',
    downloadgoodstemplate: '商品テンプレートをダウンロード',
    downloadcustomertemplate: 'クライアントテンプレートをダウンロード',
    downloadsuppliertemplate: 'ベンダーテンプレートをダウンロード',
    addupload: 'アップロード'
  },
  download_center: {
    createTime: '作成時間',
    reset: 'リセット',
    start: '始まる',
    end: '終わる'
  },
  community_mall: {
    communitymall: 'コミュニティ'
  },
  goods: {
    goods_list: '製品リスト',
    unit: '製品単位',
    class: '製品カテゴリ',
    color: '製品の色',
    brand: '製品ブランド',
    shape: '製品形状',
    specs: '製品仕様',
    origin: '製品原産地',
    view_goodslist: {
      goods_code: '製品コード',
      goods_desc: '製品説明',
      goods_name: '商品コード',
      goods_supplier: 'サプライヤー',
      goods_weight: '製品の重量（単位: グラム）',
      goods_w: '製品の長さ（単位: mm）',
      goods_d: '製品幅（単位: mm）',
      goods_h: '製品の高さ（単位: mm）',
      unit_volume: '最小単位体積',
      goods_unit: '製品単位',
      goods_class: '製品カテゴリ',
      goods_brand: '製品ブランド',
      goods_color: '製品の色',
      goods_shape: '製品の形状',
      goods_specs: '製品仕様',
      goods_origin: '製品の起源',
      goods_cost: '製品コスト',
      goods_price: '製品価格',
      print_goods_label: '商品のラベルを印刷します',
      error1: '商品コードを入力してください。',
      error2: '商品の説明を入力してください。',
      error3: '商品の仕入先を入力してください。',
      error4: '商品の重さは0より大きくなければなりません。',
      error5: '商品の長さは0より大きくなければなりません。',
      error6: '商品の幅は0より大きくなければなりません。',
      error7: '商品の高さは0より大きくなければなりません。',
      error8: '商品のコストを入力してください。',
      error9: '商品の価格を入力してください。'
    },
    view_unit: {
      goods_unit: '製品単位',
      error1: '商品単位を入力してください。'
    },
    view_class: {
      goods_class: '製品カテゴリ',
      error1: '商品の種類を入力してください。'
    },
    view_color: {
      goods_color: '製品の色',
      error1: '商品の色を入力してください。'
    },
    view_brand: {
      goods_brand: '製品ブランド',
      error1: '商品のブランドを入力してください。'
    },
    view_shape: {
      goods_shape: '製品の形',
      error1: '商品の形状を入力してください。'
    },
    view_specs: {
      goods_specs: '製品仕様',
      error1: '商品の仕様を入力してください。'
    },
    view_origin: {
      goods_origin: '製品の起源',
      error1: '商品の産地を入力してください。'
    }
  },
  inbound: {
    asn: '采购単',
    predeliverystock: '到着する',
    preloadstock: '荷降ろしする',
    presortstock: 'ソートする数量',
    sortstock: '仕分け数量',
    shortage: '到着が少ない',
    more: 'より多くの量',
    asnfinish: '収货明フィルター',
    asndone: '領収書が完了しました',
    view_sortstock: {
      error1: '数量を入力してください。数量は必ず0より大きくしてください。'
    },
    view_asn: {
      asn_code: '采购単単号',
      asn_status: '采购単様态',
      goods_qty: '采购単数量 ',
      goods_actual_qty: '実際の到着',
      goods_shortage_qty: '到着が少ない',
      goods_more_qty: 'より多くの量',
      goods_damage_qty: '倉庫に到着が破損している',
      presortstock: 'ソートする数量',
      sort_qty: '仕分け数量',
      total_weight: '総重量（単位: キログラム）',
      total_volume: '総容量（単位: 立方メートル）'
    }
  },
  outbound: {
    dn: '注文',
    freshorder: '請求前の注文',
    neworder: '新注文',
    backorder: '取り寄せ',
    pickstock: '選ばれる',
    pickedstock: '選んだ',
    pickinglist: 'ピッキングオーダー',
    shippedstock: '輸送する数量',
    received: '受け取った',
    pod: '領収書に署名する',
    view_dn: {
      dn_code: '注文号',
      dn_status: '注文态',
      goods_qty: '注文数量 ',
      intransit_qty: '輸送する数量',
      delivery_actual_qty: '実際の数量',
      delivery_shortage_qty: '到着が少ない',
      delivery_more_qty: 'その他の製品',
      delivery_damage_qty: '到着が破損しました',
      total_weight: '総重量（単位: キログラム）',
      total_volume: '総容量（単位: 立方メートル）',
      customer: '顧客名'
    }
  },
  staff: {
    staff: 'スタッフ表',
    check_code: '验证码',
    view_staff: {
      staff_name: 'スタッフ名',
      staff_type: 'スタッフクラス型',
      error1: '従業員名を入力してください',
      error2: '従業員の名前を入力してください。',
      lock: 'ロックオン',
      unlock: 'あんろっく'
    }
  },
  stock: {
    stocklist: '在庫表',
    stockbinlist: 'ロケーション表',
    emptybin: '空ロケーション ',
    occupiedbin: '有货ロケーション ',
    view_stocklist: {
      goods_code: '製品编码',
      goods_desc: '製品画像述',
      goods_qty: '总在庫',
      onhand_stock: '手持ち在庫 ',
      can_order_stock: '注文可能',
      ordered_stock: '購読済み',
      inspect_stock: '品質検査品',
      hold_stock: '锁货りん',
      damage_stock: '破損品',
      asn_stock: '采购単数量',
      dn_stock: '注文数量',
      pre_load_stock: '荷降ろしする数量',
      pre_sort_stock: 'ソートする数量',
      sorted_stock: '仕分け数量',
      pick_stock: 'ピッキングする数量',
      picked_stock: '選んだ数量',
      back_order_stock: 'バックオーダー数量',
      on_hand_inventory: '在庫品',
      history_inventory: '当時の在庫',
      physical_inventory: '棚卸しの数量',
      difference: '違い',
      cyclecount: '動的棚卸し',
      recyclecount: 'リサイクル',
      downloadcyclecount: 'カウントテーブル',
      cyclecountresult: '確認結果',
      cyclecounttip: '動的在庫テーブルを生成する',
      recyclecounttip: 'リサイクルカウントテーブルを生成する',
      downloadcyclecounttip: '在庫テーブルのダウンロード',
      cyclecountresulttip: '在庫結果を確認する',
      daychoice: '日付の選択',
      daychoicetip: '日付に対応する在庫テーブルを選択してください',
      error1: 'カウントは0より大きくしなければなりません。',
      dateerror: '間違った日付が選択されました'
    }
  },
  warehouse: {
    warehouse: '倉庫の設定',
    binset: 'ロケーション設定',
    binsize: 'ロケーションサイズ',
    property: 'ロケーション属性',
    printbin: '場所ラベルを印刷する',
    view_warehouseset: {
      error1: '倉庫名を入力してください。',
      error2: '倉庫がある都市を入力してください。',
      error3: '倉庫の住所を入力してください。',
      error4: '倉庫の連絡先を入力してください。',
      error5: '倉庫の担当者を入力してください。'
    },
    view_warehouse: {
      warehouse_name: '倉庫名',
      warehouse_city: '都市名',
      warehouse_address: '住所',
      warehouse_contact: '連絡先情報',
      warehouse_manager: '担当者',
      square_measure: 'かようめんせき',
      city_search: 'としけんさ',
      publish_warehouse: '倉庫の公開',
      Nopublish_warehouse: '倉庫をリコールする'
    },
    view_binset: {
      bin_name: 'ロケーション名称',
      bin_size: 'ロケーションサイズ',
      bin_property: 'ロケーション属性',
      empty_label: '空ロケーションマーク',
      error1: 'ライブラリ名を入力してください。',
      error2: 'ライブラリのサイズを入力してください。',
      error3: 'ライブラリの属性を入力してください。'
    },
    view_binsize: {
      bin_size: 'ロケーションサイズ',
      bin_size_w: 'ロケーション長さ(単位 :んん)',
      bin_size_d: 'ロケーション幅(単位 :んん)',
      bin_size_h: 'ロケーション高さ(単位 :んん)',
      error1: 'ライブラリのサイズを入力してください。',
      error2: 'ライブラリのビット長は0より大きくなければなりません。',
      error3: 'ライブラリの幅は0より大きい必要があります。',
      error4: 'ライブラリの高さは0より大きくなければなりません。'
    },
    view_property: {
      bin_property: 'ロケーション属性'
    }
  },
  scan: {
    scan: 'スキャン',
    scan_asn: 'ASNクエリ',
    scan_dn: 'DNクエリ',
    scan_sorting: '並べ替え',
    scan_uptobin: '棚まで',
    scan_picking: 'ピッキング',
    scan_shipping: 'ディスパッチ',
    scan_movetobin: 'ライブラリを移動',
    scan_inventory: '棚卸しをする',
    scan_goodsquery: '商品の照会',
    scan_locationquery: 'データベースの検索',
    scan_goods_code: '商品コード',
    scan_bin_name: 'ライブラリ名',
    scan_goods_label: '商品ラベル',
    scan_goods_label_error: '商品ラベルは存在しません',
    view_binmove: {
      old_bin_name: '保管場所名',
      new_bin_name: '新しいライブラリ名',
      qty: 'ライブラリ数',
      qty_error: 'スキャン数量は入荷数量より大きくない'
    },
    view_upToBin: {
      goods_actual_qty: '実績入荷数量',
      scan_qty: 'スキャン済数量',
      scan_qty_error: 'C'
    },
    view_packing: {
      order_qty: 'オーダー数量',
      packing_qty: 'ピック数量',
      packing_qty_error: 'ピック数量は注文数量より大きくない'
    },
    view_shipping: {
      shipping_code: '出荷書番号',
      driver_info: '運転手情報',
      license_plate_number: 'ナンバープレート',
      name: '名前',
      contact_info: '連絡先'
    }
  },
  handcount: {
    handcount: '単品在庫',
    handcountrecorder: '単一の在庫記録',
    update_time: 'カウント時間'
  },
  notice: {
    valerror: '正しい値を入力してください',
    unknow_error: '未知の間違い',
    network_error: 'ネットワーク異常',
    cyclecounterror: 'データなし',
    userererror: 'ユーザー名は既に存在します',
    valuenullerror: '完全なデータを入力してください',
    loginerror: '最初にログインしてください',
    goodserror: {
      goods_listerror: '商品コードは既に存在します',
      goods_uniterror: '商品ユニットはすでに存在します',
      goods_classerror: '商品カテゴリはすでに存在します',
      goods_colorerror: '商品の色はすでに存在します',
      goods_branderror: '製品ブランドはすでに存在します',
      goods_shapeerror: '商品の形状はすでに存在します',
      goods_specserror: '製品仕様はすでに存在します',
      goods_originerror: '商品の出所はすでに存在します'
    },
    baseinfoerror: {
      companyerror: '会社名はすでに存在します',
      customererror: '顧客名はすでに存在します',
      suppliererror: 'サプライヤー名はすでに存在します'
    },
    warehouseerror: {
      binseterror: 'ロケーション名は既に存在します',
      binsizeerror: 'ロケーションサイズはすでに存在します'
    },
    mobile_userlogin: {
      notice1: '管理者名を入力してください',
      notice2: '管理者パスワードを入力してください',
      notice3: 'スタッフ名を入力してください',
      notice4: 'スタッフチェックコードを入力してください',
      notice5: '設定サーバーに OpenID を入力してください',
      notice6: 'ログイン成功',
      notice7: 'ユーザーまたはパスワードが割り当てられていません',
      notice8: 'スタッフまたはチェックコードが割り当てられていません'
    },
    mobile_scan: {
      notice1: 'QRコードが存在しません',
      notice2: 'コードが存在しません',
      notice3: 'サーバー エラー',
      notice4: 'スキャンできるのはモバイルのみです'
    },
    mobile_asn: {
      notice1: '到着通知のリスト',
      notice2: '到着通知のQRコードをスキャンするか,到着通知をクリックすると,到着通知の詳細を表示して操作できます',
      notice3: 'サプライヤー:',
      notice4: '合計金額:',
      notice5: 'ステータス:',
      notice6: '到着通知の詳細',
      notice7: '到着通知の詳細を取得するには,到着通知をスキャンする必要があります。貨物コードをスキャンするか,棚に置きたい商品をクリックして,棚の商品の操作を完了できます',
      notice8: '詳細',
      notice9: '合計金額:',
      notice10: '掲載番号:',
      notice11: 'リストの数は 0 より大きい必要があります',
      notice12: '上場成功',
      notice13: 'ロケーション コードを入力してください'
    },
    mobile_dn: {
      notice1: '請求書一覧',
      notice2: '請求書の QR コードをスキャンするか,請求書をクリックして請求書の詳細を表示し,操作を実行できます',
      notice3: 'お客様:',
      notice4: '合計金額:',
      notice5: 'ステータス:',
      notice6: '請求書の詳細',
      notice7: '請求書の詳細はすべて請求書です。特定の請求書の詳細を表示するには,請求書をスキャンしてください',
      notice8: '詳細',
      notice9: '合計金額:',
      notice10: '請求数量:',
      notice11: 'ピッキング リストの詳細はすべてここにあります。特定の商品または請求書をスキャンして,ピッキング リストを操作することもできます',
      notice12: '特定のピッキング数量を入力してください',
      notice13: 'ピッキング成功',
      notice14: 'ロケーション名:',
      notice15: 'ピッキングする数量:'
    },
    mobile_goodsstock: {
      notice1: '在庫リスト',
      notice2: 'ここですべての在庫情報を確認できます。クリックすると在庫情報を直接表示できます',
      notice3: '手持ち在庫:',
      notice4: '発注可能数:'
    },
    mobile_binstock: {
      notice1: '在庫在庫',
      notice2: 'ここでは,すべての倉庫の場所の在庫情報を確認したり,クリックして倉庫の場所の在庫に直接アクセスしたり,倉庫転送操作を実行したり,商品をスキャンしてすべての商品の保管状況を確認したりできます',
      notice3: 'ロケーションコード:',
      notice4: '保管数量:',
      notice5: 'ロケーション コードを入力してください',
      notice6: 'リポジトリは正常に移動しました'
    },
    mobile_emptybin: {
      notice1: 'ロケーションリストが空です',
      notice2: 'ここにすべての空の倉庫が表示されます',
      notice3: '在庫場所属性:'
    },
    equipment: {
       notice1: '対応デバイス一覧',
       notice2: 'APP でサポートされているすべてのデバイス ブランドとシステムがここにリストされています'
     },
    handcount: {
      notice1: '詳細',
      notice2: '手動インベントリ',
      notice3: '既存在庫',
      notice4: 'カウント カウント',
      notice5: '結果を確認する',
      notice6: '棚卸結果の確認',
      notice7: '棚卸が成功したことを確認しました',
      notice8: 'ここにカウントする必要がある商品の詳細が表示されます'
    },
    400: '不正なリクエスト（400）',
    401: '認証が取得されていません（401）',
    403: 'アクセスが拒否されました（403）',
    404: 'リソースが存在しません（404）',
    405: '機能が無効になっています（405）',
    408: 'リクエストがタイムアウトしました（408）',
    409: 'データの競合（409）',
    410: 'データが削除されました（410）',
    500: 'サーバーエラー（500）',
    501: 'サービスが実装されていません（501）',
    502: 'ネットワークエラー（502）',
    503: 'サービスを利用できません（503）',
    504: 'ネットワークタイムアウト（504）',
    505: 'HTTPバージョンはサポートされていません（505）'
  }
}
